import { Table, TableBody, TableHeader } from 'primitives/table'
import { SkeletonFilters } from './table-filters-skeleton'
import { SkeletonTableHeader } from './table-header-skeleton'
import { SkeletonTableBody } from './table-body-skeleton'
import { SkeletonFooter } from './table-footer-skeleton'

interface DataTableSkeletonProps {
  columnCount: number
  rowCount?: number
  searchableColumnCount?: number
  filterableColumnCount?: number
  showViewOptions?: boolean
  cellWidths?: string[]
  shrinkZero?: boolean
}

export const DataTableSkeleton = ({
  columnCount,
  rowCount = 10,
  searchableColumnCount = 0,
  filterableColumnCount = 0,
  showViewOptions = true,
  cellWidths = ['auto'],
  shrinkZero = false,
}: DataTableSkeletonProps) => (
  <div className="w-full space-y-3 overflow-auto">
    <SkeletonFilters
      searchableColumnCount={searchableColumnCount}
      filterableColumnCount={filterableColumnCount}
      showViewOptions={showViewOptions}
    />
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <SkeletonTableHeader
            columnCount={columnCount}
            cellWidths={cellWidths}
            shrinkZero={shrinkZero}
          />
        </TableHeader>
        <TableBody>
          <SkeletonTableBody
            columnCount={columnCount}
            rowCount={rowCount}
            cellWidths={cellWidths}
            shrinkZero={shrinkZero}
          />
        </TableBody>
      </Table>
    </div>
    <SkeletonFooter />
  </div>
)
